import { render, staticRenderFns } from "./loadingOrderRecord.vue?vue&type=template&id=13f92646&scoped=true"
import script from "./loadingOrderRecord.vue?vue&type=script&lang=js"
export * from "./loadingOrderRecord.vue?vue&type=script&lang=js"
import style0 from "./loadingOrderRecord.vue?vue&type=style&index=0&id=13f92646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f92646",
  null
  
)

export default component.exports